function ApiService() {

    let config = {
        apiBaseUrl: 'https://hndepotrum.api.depotbook.dk/api/',
        token: null
    }

    let api = {}

    api.configure = (configuration) => {
        for (let attr in configuration) {
            config[attr] = configuration[attr]
        }
    }

    // Make a request to the API
    api.request = (args) => {
        // Destructure arguments into local variables
        let {
            method,
            endpoint,
            data
        } = args

        // Set method to uppercase (e.g. "POST", "GET"), just in case
        method = method.toUpperCase()

        // Build URL
        let url = `${config.apiBaseUrl}${endpoint}`

        // Build headers
        let headers = {
            'Content-Type': 'application/json; chartset=utf-8'
        }

        // Add authentication token to request
        if (config.token) {
            headers['Authorization'] = `Bearer ${config.token}`
        }

        // Setup options for fetch()
        let options = {
            method,
            headers
        }

        // Add post data
        if (['POST', 'PUT'].indexOf(method) >= 0) {
            options.body = JSON.stringify(data)
        }

        // Create request
        let request = fetch(url, options)
            .then(response => {
                // Handle non 200 - OK responses
                if (!response.ok) {
                    return Promise.reject(response)
                }

                // Convert status 200 response to JSON
                return response.json()
            })

        // Return fetch() request
        return request
    }

    api.getPaymentToken = ({ customer_id, order_id, resource_id, isExistingUser }) => {
        return api.request({
            endpoint: 'payment/token',
            method: 'post',
            data: {
                customer_id,
                resource_id,
                order_id,
                isExistingUser
            }
        })
    }

    // Get list of locations
    api.getLocations = () => {
        return api.request({
            endpoint: `location`,
            method: 'get'
        })
    }


    // Get list of storage rooms
    api.getStorageRooms = (location_id) => {
        return api.request({
            endpoint: `resource/getfree?location=${location_id}`,
            method: 'get'
        })
    }

    // Get list of groups
    api.getGroups = () => {
        return api.request({
            endpoint: 'group/getall',
            method: 'get'
        })
    }

    // Get list of storage locations
    api.getStorageLocations = () => {
        return api.request({
            endpoint: 'location/getall',
            method: 'get'
        })
    }

    api.createCustomer = (data) => {
        return api.request({
            endpoint: 'customer',
            method: 'post',
            data
        })
    }

    api.getCustomerData = () => {
        return api.request({
            endpoint: 'customerbackend/customerdata',
            method: 'get'
        })
    }

    // Authenticate user and set token for future requests
    api.authenticateUser = (data) => {
        return api.request({
                endpoint: 'auth',
                method: 'post',
                data
            })
            .then(response => {
                api.configure({
                    token: response.token
                })

                return response
            })
    }

    api.login = ({username, password}) => {
        return api.request({
            endpoint: 'login/customerlogin',
            method: 'post',
            data: { username, password }
        })
    }

    // Set token to null
    api.logout = () => {
        api.configure({
            token: null
        })
    }

    api.createBooking = (data) => {
        return api.request({
            endpoint: 'booking',
            method: 'post',
            data
        })
    }

    api.unlockBooking = ({customer_id, order_id}) => {
        return api.request({
            endpoint: 'utility/bamboracancel',
            method: 'post',
            data: {
                customer_id,
                order_id
            }
        })
    }

    api.orderStatus = (id) => {
        return api.request({
            endpoint: `booking/${id}/ispayed`,
            method: 'get'
        })
        .then(response => {
            let status = response.recurringpayment.length > 0 ? 'confirmed' : 'unconfirmed'

            return { status }
        })
    }

    return api

}

export default new ApiService()



// WEBPACK FOOTER //
// ./src/services/ApiService.js